<template>
  <div v-if="task">
    <router-link v-if="task.id" :to="projectRoute" class="button is-default mb">Back to Project</router-link>
    <div class="columns between">
      <div class="column">
        <h1 ref="title" class="title is-3 is-marginless between-center contenteditable">{{ task.title }}</h1>
        <h2 class="subtitle mt-5">
          Project:
          <router-link :to="{ name: 'projects.show', params: { slug: task.project_id } }">
            {{ projectNameById(task.project_id) }}
          </router-link>
        </h2>
      </div>
      <div class="column field is-grouped is-grouped-right is-flex-wrap">
        <router-link :to="backlink(projectRoute)" class="button control is-default">Back</router-link>
        <a @click.prevent="openGlobalTimelog({ project_id: task.project_id, activity_id: task.id })"
           class="button control is-primary">Log Time</a>
        <a @click.prevent="isReminderModalActive = true" class="button control is-info">Set Reminder</a>
        <a @click.prevent="isPreviewModalActive = true" class="button control is-info">Print</a>
        <a @click.prevent="handleRemove" class="button control is-danger">Delete</a>
        <a @click.prevent="handleEdit" class="button control is-info">Edit</a>
      </div>
    </div>
    <div class="columns is-multiline">
      <div class="column is-12-tablet is-12-desktop is-3-widescreen">
        <info :task="task"/>
      </div>

      <div class="column is-12-tablet is-12-desktop is-9-widescreen">
        <o-tabs type="is-boxed">
          <o-tab-item label="Discussion">
            <notes
                :reference-id="task.id"
                reference-type="task"
            />
          </o-tab-item>

          <o-tab-item label="Files">
            <files
                :reference-id="task.id"
                reference-type="task"
            />
          </o-tab-item>
        </o-tabs>
      </div>
    </div>

    <o-modal
        :can-cancel="['escape', 'outside', 'button']"
        v-model:active="isReminderModalActive"
        has-modal-card
    >
      <reminder-modal
          :reference-id="task.id"
          reference-type="task"
      />
    </o-modal>

    <o-modal
        :can-cancel="['escape', 'outside', 'button']" v-model:active="editModalActive"
        has-modal-card
    >
      <edit-modal :item="editItem"/>
    </o-modal>

    <o-modal
        :can-cancel="['escape', 'outside', 'button']" v-model:active="isPreviewModalActive"
        class="preview-modal"
        has-modal-card
    >
      <preview-modal :file="previewFile"/>
    </o-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import Backlink from '../../mixins/Backlink'
import Files from './../../components/Files'
import PreviewModal from './../../components/modals/Preview'
import Notes from './../../components/Notes'
import EditModal from './show/EditModal'
import Info from './show/Info'

export default {
  mixins: [Backlink],

  components: {
    PreviewModal,
    EditModal,
    Notes,
    Files,
    Info
  },

  data() {
    return {
      isReminderModalActive: false,
      isPreviewModalActive: false,
      isTimeLogModalActive: false,
      editModalActive: false,
      previewFile: null,
      editItem: null,
      task: null
    }
  },

  computed: {
    ...mapGetters([
      'notesByReference',
      'projectNameById',
      'currentUserId',
      'userNameById',
      'allUsers',
      'projects',
      'taskById'
    ]),

    projectRoute() {
      return {
        name: 'projects.show.tasks',
        params: {
          slug: this.task.project_id
        }
      }
    }
  },

  mounted() {
    this.fetchTaskById(this.$route.params.slug)
        .then(() => {
          this.task = this.taskById(this.$route.params.slug)

          const port = window.location.port ? `:${window.location.port}` : ''
          this.previewFile = {
            name: this.task.title,
            mime: 'application/pdf',
            path: `${window.location.protocol}//${window.location.hostname}${port}/tasks/${this.task.id}/pdf`,
            generatedOnTheFly: true
          }
        })
  },
  methods: {
    ...mapActions([
      'openGlobalTimelog',
      'fetchTaskById',
      'updateTask',
      'removeTask',
      'fetchProjectById',
      'setCurrentProjectId'
    ]),

    handleEdit() {
      this.editItem = this.task
      this.editModalActive = true
    },

    handleRemove() {
      this.confirmMessage(
          'Are you sure?',
          'This action cannot be undone.',
          'Yes'
      ).then(() => {
        this.removeTask(this.task)
            .then(res => {
              this.task = null
              this.$router.push(this.backlink(this.projectRoute))
              return res
            })
      })
    },

    handleUpdate() {
      this.task.title = this.$refs.title.innerText
      let submit = this.wrapSubmit(this.updateTask)
      submit(this.task)
          .then(res => {
            this.success()
            return res
          })
    },

    success() {
      this.$swal.fire({
        text: 'Task has been updated',
        icon: 'success'
      })
    }
  }
}
</script>
